import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-300">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-12">
        <div className="py-14 md:py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-5">
              <span className="font-heading text-2xl font-bold text-primary-500">17黑料网</span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed max-w-xs">
              全网独家吃瓜追踪平台，每日更新网红黑料、塌房事件、争议热点。理性吃瓜，不传谣不信谣。
            </p>
            <div className="flex gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500/30 text-foreground-400 hover:text-primary-400 transition-all duration-200" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500/30 text-foreground-400 hover:text-primary-400 transition-all duration-200" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500/30 text-foreground-400 hover:text-primary-400 transition-all duration-200" aria-label="抖音">
                <i className="ri-tiktok-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500/30 text-foreground-400 hover:text-primary-400 transition-all duration-200" aria-label="B站">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          {categories.slice(0, 3).map((cat) => (
            <div key={cat.id}>
              <h4 className="font-heading text-base font-semibold text-foreground-200 mb-5">
                <Link to={`/category/${cat.slug}`} className="hover:text-primary-400 transition-colors">
                  {cat.name}
                </Link>
              </h4>
              <ul className="flex flex-col gap-3">
                <li>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors">
                    最新{cat.name}
                  </Link>
                </li>
                <li>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors">
                    热门{cat.name}
                  </Link>
                </li>
                <li>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors">
                    {cat.name}排行
                  </Link>
                </li>
                <li>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors">
                    {cat.name}专题
                  </Link>
                </li>
              </ul>
            </div>
          ))}

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-200 mb-5">关于我们</h4>
            <ul className="flex flex-col gap-3">
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors">品牌介绍</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors">联系我们</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors">侵权申诉</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors">商务合作</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 py-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; 2026 17黑料网 版权所有 | 本站内容仅供娱乐参考，请理性看待
            </p>
            <div className="flex items-center gap-4 text-xs text-foreground-500">
              <a href="#" className="hover:text-foreground-300 transition-colors">隐私政策</a>
              <a href="#" className="hover:text-foreground-300 transition-colors">用户协议</a>
              <a href="#" className="hover:text-foreground-300 transition-colors">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}